import { Loader2 } from "lucide-react";

export const Initialize = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen gap-8 sm:gap-16 bg-gradient-to-b from-background to-muted/20">
            <img src="/img/logo.svg" alt="Exibra CMS" className="max-w-full px-16" />
            <Loader2 className="w-4 h-4 animate-spin sm:h-10 sm:w-10" />
        </div>
    );
};
